import { ADMIN_DASHBOARD_COPY } from '@sonar-software/sonar-ts-constants';
import { Button } from 'antd';
import { AzureIcon, GoogleIcon, OktaIcon, OneLoginIcon } from '.';
import React, { useCallback } from 'react';
export const OidcProviderSetupSelector = (props) => {
    const { onProviderSelected } = props;
    const handleClick = useCallback((provider) => {
        if (onProviderSelected) {
            onProviderSelected(provider);
        }
    }, [onProviderSelected]);
    return (React.createElement("div", null,
        React.createElement(Button, { className: 'oidc-provider-selection-btn', icon: React.createElement(OktaIcon, null), onClick: () => handleClick('okta') }, ADMIN_DASHBOARD_COPY.ADD_OKTA_CONFIG),
        React.createElement(Button, { className: 'oidc-provider-selection-btn', icon: React.createElement(AzureIcon, null), onClick: () => handleClick('azure') }, ADMIN_DASHBOARD_COPY.ADD_AZURE_CONFIG),
        React.createElement(Button, { className: 'oidc-provider-selection-btn', icon: React.createElement(GoogleIcon, null), onClick: () => handleClick('google') }, ADMIN_DASHBOARD_COPY.ADD_GOOGLE_CONFIG),
        React.createElement(Button, { className: 'oidc-provider-selection-btn', icon: React.createElement(OneLoginIcon, null), onClick: () => handleClick('onelogin') }, ADMIN_DASHBOARD_COPY.ADD_ONELOGIN_CONFIG)));
};
